import React, { Component } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import InnerLoader from "../../Shared/Loader/InnerLoader";
import Loader from "../../Shared/Loader/loader";
import { PageContainer } from "../../Drawer/PageContainer";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { withTranslation } from "react-i18next";
import { getPortalEntitiesAndPagesConfigurations, updateEntitiesConfigurations } from "../../../API/Entity/Entity";

class Entities extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            entitiesToUpdate: [],
            removedFromPortal: [],
            dataLoading: true,
            isLoading: false
        };
    }

    componentDidMount = async () => {
        let data = await getPortalEntitiesAndPagesConfigurations(this.props.portal._id, this.props.project._id);
        const entities = data
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((entity, index) => ({
                ...entity,
                indexId: index + 1
            }));
        let dataLoading = false;
        this.setState({
            data: [...entities],
            dataLoading
        });
    };

    render() {
        const { t } = this.props;
        if (this.state.dataLoading) {
            return <Loader />;
        }
        return (
            <PageContainer>
                {this.state.showEntityRemoveWarning && (
                    <Dialog
                        width={"35%"}
                        title={t("entity_removal_dialog.title")}
                        onClose={this.cancelSave}>
                        <div className="mt-3 dialog-content">
                            <p>
                                {t("entity_removal_dialog.warning1", { entityName: this.getNameOfEntitiesRemoved() })}
                            </p>
                            <p>
                                {t("entity_removal_dialog.warning2", { entityName: this.getNameOfEntitiesRemoved() })}
                            </p>
                            <p>
                                {t("entity_removal_dialog.warning3")}
                            </p>
                        </div>
                        <DialogActionsBar layout="end">
                            <div className="mb-2 me-2">
                                <button autoFocus={true} onClick={this.cancelSave} className="btn btn-secondary">
                                    {t("entity_removal_dialog.buttons.cancel_button_label")}
                                </button>
                                <button onClick={this.saveConfiguration} className="btn btn-danger">
                                    {t("entity_removal_dialog.buttons.proceed_button_label")}
                                </button>
                            </div>
                        </DialogActionsBar>
                    </Dialog>
                )}
                <div className="container-fluid">
                    {this.state.data.length !== 0 && (
                        <div className="row">
                            <div className="col-12 my-1">
                                <div className="d-flex justify-content-end align-items-center">
                                    {this.state.isLoading && (
                                        <span className="mx-4">
                                            <InnerLoader borderColor="green" />
                                            <span className="text-success"></span>
                                        </span>
                                    )}
                                    <button
                                        className="mx-2 btn btn-primary"
                                        onClick={this.save}
                                        disabled={this.state.entitiesToUpdate.length === 0}
                                    >
                                        <i class="fas fa-save me-1"></i>
                                        {t("buttons.save_button_label")}
                                    </button>
                                    <Menu onSelect={(e) => e.item.data()} className="no-dropdown-in-menu">
                                        <MenuItem cssClass="btn btn-secondary px-1" icon="more-horizontal g-0 m-0 ps-2" data={() => { }}>
                                            <MenuItem text={t("buttons.revert_changes")} icon="undo" disabled={this.state.entitiesToUpdate.length === 0} data={this.reset} />
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </div>
                            <div className="col me-2 ms-1">
                                <div className="ms-1">
                                    <Grid data={this.state.data}>
                                        <Column field="indexId" title="#" width={40} />
                                        <Column
                                            title={t("grid.header.objects")}
                                            cell={(props) => (
                                                <td>
                                                    <span>
                                                        {props.dataItem.name}
                                                    </span>
                                                </td>
                                            )}
                                        />
                                        <Column
                                            title={t("grid.header.use_in_portal")}
                                            cell={(props) => (
                                                <td>
                                                    <Checkbox
                                                        checked={this.getUseInPortalValue(props.dataItem)}
                                                        onChange={this.handleUseInPortalCheckBox}
                                                        name="useInPortal"
                                                        data-key={props.dataItem._id}
                                                        disabled={props.dataItem.isUserEntity}
                                                    />
                                                </td>
                                            )}
                                        />ß
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </PageContainer >
        );
    }

    goToEntity = () => {
        window.location.href = `/${this.props.organization.orgName}/${this.props.project.name}/Entities`;
    };

    getUseInPortalValue = (entity) => {
        const configuration = entity.configurations[this.props.portal._id];
        if (configuration === undefined) {
            return false
        }
        return configuration.useInPortal;
    };

    handleUseInPortalCheckBox = (e) => {
        const { checked } = e.target.element;
        const dataKey = e.target.element.getAttribute("data-key");
        let { data, entitiesToUpdate } = this.state;

        const entityIndex = data.findIndex((e) => e._id === dataKey);
        const entity = data[entityIndex];
        const entityConfiguration = entity.configurations[this.props.portal._id];

        const removedFromPortal = this.getNewRemovedFromPortalValue(
            dataKey,
            checked
        );

        entityConfiguration.useInPortal = checked;
        
        // Handle mobile portal differently
        if (this.props.portal.isMobilePortal) {
            if (checked) {
                // For mobile portal, only enable specific features
                entityConfiguration.shouldCreateCards = true;
                entityConfiguration.shouldCreateDetailsView = true;
                entityConfiguration.shouldCreateEditRecord = true;
                entityConfiguration.shouldCreateNewRecord = true;
                // Keep other features disabled for mobile
                entityConfiguration.shouldCreateSplitView = false;
                entityConfiguration.shouldCreateCalendar = false;
                entityConfiguration.shouldCreateTable = false;
                entityConfiguration.shouldCreateKanban = false;
            } else {
                // If unchecked, disable all features
                entityConfiguration.shouldCreateCards = false;
                entityConfiguration.shouldCreateDetailsView = false;
                entityConfiguration.shouldCreateEditRecord = false;
                entityConfiguration.shouldCreateNewRecord = false;
                entityConfiguration.shouldCreateSplitView = false;
                entityConfiguration.shouldCreateCalendar = false;
                entityConfiguration.shouldCreateTable = false;
                entityConfiguration.shouldCreateKanban = false;
            }
        } else {
            // For non-mobile portals, keep existing behavior
            entityConfiguration.shouldCreateCards = checked;
            entityConfiguration.shouldCreateDetailsView = checked;
            entityConfiguration.shouldCreateEditRecord = checked;
            entityConfiguration.shouldCreateNewRecord = checked;
            entityConfiguration.shouldCreateSplitView = checked;
            entityConfiguration.shouldCreateCalendar = checked;
            entityConfiguration.shouldCreateTable = checked;
            entityConfiguration.shouldCreateKanban = checked;
        }

        const exist = entitiesToUpdate.findIndex((e) => e._id === dataKey);
        if (exist < 0) {
            entitiesToUpdate.push(entity);
        } else {
            entitiesToUpdate = entitiesToUpdate.filter((e) => e._id !== dataKey);
        }

        this.setState({
            data,
            entitiesToUpdate,
            removedFromPortal,
        });
    };

    getNewRemovedFromPortalValue = (entityId, newState) => {
        const newRemovedFromPortal = this.state.removedFromPortal.slice();
        const entityIndex = newRemovedFromPortal.findIndex(
            (element) => element === entityId
        );
        if (newState === true) {
            if (entityIndex > -1) {
                newRemovedFromPortal.splice(entityIndex, 1);
            }
        } else if (newState === false) {
            const entity = this.state.data.find(element => element._id === entityId);
            if (entity.numberOfPages > 0) {
                newRemovedFromPortal.push(entityId);
            }
        }
        return newRemovedFromPortal;
    };

    getNameOfEntitiesRemoved = () => {
        const names = [];
        const { entitiesToUpdate } = this.state;
        for (const entity of entitiesToUpdate) {
            const entityConfiguration = entity.configurations[this.props.portal._id];
            if (!entityConfiguration.useInPortal) {
                names.push(entity.name);
            }
        }
        return names.join(', ');
    }

    IsAllEntitiesBeDisabled = (data) => {
        for (let entity of data) {
            const entityConfiguration = entity.configurations[this.props.portal._id];
            if (entityConfiguration.useInPortal) {
                return false;
            }
        }
        return true;
    }

    save = () => {
        debugger
        const isAnyEntityRemovedFromPortal = this.entitiesRemovedFromPortal();
        if (isAnyEntityRemovedFromPortal === true) {
            this.setState({
                showEntityRemoveWarning: true
            });
        } else {
            this.saveConfiguration();
        }
    };

    cancelSave = () => {
        this.setState({
            showEntityRemoveWarning: false
        })
    }

    saveConfiguration = async () => {
        const { entitiesToUpdate } = this.state;
        await updateEntitiesConfigurations(entitiesToUpdate, this.props.portal._id);

        this.setState({
            entitiesToUpdate: [],
            showEntityRemoveWarning: false,
            removedFromPortal: []
        });
    };

    entitiesRemovedFromPortal = () => {
        return this.state.removedFromPortal.length > 0;
    };

    reset = () => {
        const { entitiesToUpdate, data } = this.state;
        for (let entity of data) {
            const exist = entitiesToUpdate.find(e => e._id === entity._id);
            if (exist) {
                entity.configurations[this.props.portal._id].useInPortal = !entity.configurations[this.props.portal._id].useInPortal;
                entity.configurations[this.props.portal._id].shouldCreateCards = !entity.configurations[this.props.portal._id].shouldCreateCards;
                entity.configurations[this.props.portal._id].shouldCreateDetailsView = !entity.configurations[this.props.portal._id].shouldCreateDetailsView;
                entity.configurations[this.props.portal._id].shouldCreateEditRecord = !entity.configurations[this.props.portal._id].shouldCreateEditRecord;
                entity.configurations[this.props.portal._id].shouldCreateNewRecord = !entity.configurations[this.props.portal._id].shouldCreateNewRecord;
                entity.configurations[this.props.portal._id].shouldCreateSplitView = !entity.configurations[this.props.portal._id].shouldCreateSplitView;
                entity.configurations[this.props.portal._id].shouldCreateCalendar = !entity.configurations[this.props.portal._id].shouldCreateCalendar;
                entity.configurations[this.props.portal._id].shouldCreateTable = !entity.configurations[this.props.portal._id].shouldCreateTable;
                entity.configurations[this.props.portal._id].shouldCreateKanban = !entity.configurations[this.props.portal._id].shouldCreateKanban;
            }
        }
        const removedFromPortal = [];
        this.setState({
            data: [...data],
            entitiesToUpdate: [],
            removedFromPortal,
        });
    };
}

export default withTranslation([
    "portal/objects_selection",
])(Entities);
